/**
 * The Stocks API path.
 */
export const stocksAPIPath = "/stocks";
/**
 * The Stock Logo endpoint suffix.
 */
export const stockLogoEndpointSuffix = "/logo";
